import axios from 'axios';
import { apiGateway } from 'constants/index';

const axiosInstance = (method) => axios.create({
  method,
});

export const uploadImage = async (image, name, bucketAlias, folder, totalData) => {
  try {
    const instance = axiosInstance('post');

    delete instance.defaults.headers;
    instance.defaults.headers = {
      'Content-Type': 'application/json',
    };

    const endPoint = `${apiGateway}/generate-s3-url`;
    const data = {
      fileName: name,
      fileType: image.type,
      target: bucketAlias,
      folder,
    };

    const responseApi = await instance.post(endPoint, data);

    if (responseApi.status !== 200) throw new Error('No se pudo obtener la URL pre-firmada');

    const { uploadUrl, publicUrl } = responseApi.data;

    const instanceS3 = axiosInstance('put');
    delete instanceS3.defaults.headers;
    instanceS3.defaults.headers = {
      'Content-Type': image.type,
    };

    const responseS3 = await instanceS3.put(uploadUrl, image);

    if (responseS3.status === 200) {
      return totalData ? responseApi.data : publicUrl;
    }

    throw new Error('S3 rechazó el archivo');
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default {
  uploadImage,
};
